const part = [
    {
        path: 'refund-list',
        name: 'refund-list',
        meta: {
            icon: 'md-stats',
            title: '提现单',
            notCache: true,
            access: ['S', 'I', 'J'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/refund/refund-list')
    }
];

export default part;